export default {
  MsComboboxLoadData: 'comboboxLoadData',
  MSComboboxFirstLoadDataLocal: 'comboboxLoadDataLocal',
  MsKeydown: 'msKeydown',
};
